// extracted by mini-css-extract-plugin
export default {"button":"LinkButton_button__bhO8B","slide":"LinkButton_slide__wSE6P"};